import * as Sentry from '@sentry/react';
import { runtimeConfig } from '@/lib/runtime-config';

declare const __APP_VERSION__: string;

/**
 * La replay riprende dati finanziari e anagrafiche dei tenant: testi
 * mascherati e media bloccati, sempre.
 */
export const SENTRY_REPLAY_PRIVACY = {
  maskAllText: true,
  blockAllMedia: true,
} as const;

export function initSentry() {
  const dsn = runtimeConfig.VITE_SENTRY_DSN_BACKOFFICE;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: runtimeConfig.VITE_APP_ENV || import.meta.env.MODE,
    release: __APP_VERSION__,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(SENTRY_REPLAY_PRIVACY),
    ],
    tracesSampleRate:
      (runtimeConfig.VITE_APP_ENV || import.meta.env.MODE) === 'production'
        ? 0.2
        : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      /Loading chunk .* failed/,
    ],
    denyUrls: [/extensions\//i, /^chrome:\/\//i],
  });

  Sentry.setTag('app', 'backoffice');
}
